import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { PermissionsService } from '../services/permissions/permissions.service';
import { canSeeUsageMetrics } from '../usage-metrics/usage-metrics-access';

export const usageMetricsGuard: CanActivateFn = () => {
  const router = inject(Router);
  const denied = () => router.createUrlTree(['/minhas-cameras']);

  return inject(PermissionsService)
    .resolveMe()
    .pipe(map((me) => canSeeUsageMetrics(me) || denied()));
};
